export const SET_FACTURES_CA = "SET_FACTURES_CA";

export const fetchFacturesCA = (token) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    
        return async (dispatch) => {
            try {
                const response = await fetch(`${apiUrl}/api/facture/ca`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
    
                const data = await response.json();
    
                if (!response.ok) {
                    throw new Error(data.error || "Erreur lors de la récupération des notifications");
                }
    
                dispatch({
                    type: SET_FACTURES_CA,
                    payload: data.facturesCA || [],
                });
            } catch (error) {
                console.error("Erreur fetchFacturesCA :", error);
            }
        };
}